<template>
  <div id="tour-booking-params" class="tour-booking-params mb-3">
    <b-row>
      <b-col md="6" lg="4" xl="4">
        <b-form-group>
<!--          <label>Даты выезда</label>-->
          <tour-dates-input :tour="tour"
                            @change="on_change_date"
          />
        </b-form-group>
      </b-col>
      <b-col md="6" lg="5" xl="4">
        <b-form-group>
<!--          <label>Туристы</label>-->
          <tourists-input :tourists="tourists"
                          :min_age="tour.min_age"
                          @change="on_change_tourists"
          />
        </b-form-group>
      </b-col>
      <b-col md="12" lg="3" xl="4">
        <b-form-group>
          <div v-if="tour.one_day"
               class="one-day-price">
            <CombinationPrice
                :price="one_day_price"
                :discount="discount_precalc"
                :discount_type="discount_type"
                direction="row"
                align="center"
            ></CombinationPrice>
          </div>
          <b-button
              v-else
              @click="on_submit"
              :variant="button_style"
              class="btn-block">
            Показать
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import TouristsInput from "../tours_search/TouristsInput";
import TourDatesInput from "./TourDatesInput";
import {age_groups_for} from "../../../components/shared/tour_herpers";
import CombinationPrice from "./CombinationPrice";

export default {
  components: {CombinationPrice, TourDatesInput, TouristsInput},
  props:{
    tourists: Object,
    tour: Object,
  },
  data(){
    return {
      selected_date: {},
      localTourists: this.tourists,
      form_state: "changed",
    }
  },
  computed:{
    discount(){
      this.selected_date = this.selected_date;
      if (this.selected_date.attributes) {
        return this.selected_date.attributes.discount;
      } else {
        return false;
      }
    },
    discount_type(){
      this.selected_date = this.selected_date;
      if (this.selected_date.attributes) {
        return this.selected_date.attributes.discount_type;
      } else {
        return 'no_discount';
      }
    },
    discount_precalc(){
      this.selected_date = this.selected_date;
      if (this.discount_type == 'fixed_value') {
        return this.discount * this.localCombination.person_quantity;
      } else {
        return this.discount;
      }
    },

    is_changed(){
      return this.form_state == 'changed';
    },
    is_up_to_date(){
      return this.form_state == 'up_to_date';
    },
    is_loading(){
      return this.form_state == 'loading';
    },
    button_style(){
      return this.is_changed ? 'secondary' : 'light'
    },
    one_day_price(){
      this.selected_date = this.selected_date;
      if (!this.tour.one_day) return false;
      if (!this.selected_date.id) return "~";
      let age_groups = age_groups_for(this.tour, this.localTourists.adults, this.localTourists.kids);
      // console.log('AGE GROUPS', age_groups);
      let price = 0;
      price += this.selected_date.attributes.adult_price * age_groups.adults;
      price += this.selected_date.attributes.kid_price   * age_groups.kids;
      price += this.selected_date.attributes.baby_price  * age_groups.babies;
      return price;


    },
  },

  methods: {
    on_change_tourists(tourists){
      // console.log('on_change_tourists');
      this.$set(this, 'form_state', 'changed');
      this.$set(this, 'localTourists', tourists);
      this.$emit('change', this.selected_date, this.localTourists, this.one_day_price)
    },
    on_change_date(tour_date){
      // console.log('TourDatesParams handle object (on_change_date)');
      this.$set(this, 'form_state', 'changed');
      this.$set(this, 'selected_date', tour_date);
      this.$emit('change', this.selected_date, this.localTourists, this.one_day_price)
    },
    on_submit(){
      // console.log('on_submit');
      this.fb_track('ViewContent');
      this.$set(this, 'form_state', 'is_up_to_date');
      this.$emit('submit', this.selected_date, this.localTourists)
    },
    fb_track(event){
      if (typeof fbq !== 'undefined' && this.role !== 'agent') fbq('track', event);
    }

  }
}
</script>
